import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div className="pub-not-found-container">
        <div className="pub-not-found-content">
          <h1 className="pub-not-found-title">404</h1>
          <h2 className="pub-not-found-subtitle">Coach Not Found</h2>
          <p className="pub-not-found-description">
            The coach profile you're looking for doesn't exist or has been removed.
          </p>
          <a href="/" className="pub-not-found-button">
            Go to Homepage
          </a>
        </div>
      </div>
    );
  }
}

export default NotFound;
